/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ComponentInterface } from '../../canvas-common/interfaces/component.interface';
import { TicketContainer, TICKET_CHANGE_EVENTS } from '../tickets/TicketContainer';
import { Texture } from 'pixi.js-legacy';
import { TicketComponentHelper } from './TicketComponentHelper';
import { Side } from '@touchplan/common';
import { Ticket } from '@touchplan/common';
import { FancyText } from '@appCanvasCommon/fontpath/FancyText';
import { HighResolutionText } from '@appCanvasCommon/text/HighResolutionText';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { planRendererInfo } from '@appCanvasCommon/core/RendererInfo';
import { setTicketWidthHelper } from 'src/app/utils/ticket-utils';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';

export enum TICKET_DURATION_DAYS_SETTINGS {
	// padding-bottom: 20px
	// Align to bottom-left, then offset the height and 20
	// 28 is the height of TicketCrewSize.
	// 20 is the spacing we want.
	// Using the height of TicketCrewSize instead of this.height so all of the icons line-up neatly (Duration Days icon is larger than Crew Size)
	PADDING_BOTTOM = 10,
	ROW_HEIGHT = 35,
}

export class TicketDurationDays extends TicketComponentHelper implements ComponentInterface {
	private _value: FancyText | HighResolutionText;

	constructor(texture: Texture, canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		super(texture, canvasAngularLand, ticketContainer);

		// Fall back to Canvas if WebGL is not available
		if (planRendererInfo.isWebGL()) {
			this._value = new FancyText('Roboto Medium');
			this._value.active = true;
			this._value.visible = true;

			this._value.x = this.texture.width + 17;
			this._value.fontSize = 96; // 32px * 3x scale factor = 96;
		} else {
			this._value = new HighResolutionText('');
			this._value.active = true;
			this._value.visible = true;

			this._value.x = this.texture.width + 20;
			this._value.style.fontSize = 96; // 32px * 3x scale factor = 96;
		}

		this._value.enableTrimText = false;

		this.addChild(this._value);

		this.width = 30;
		this.height = 35;

		ticketContainer.on(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);
		this._value.on('triangulationFinished', this.setPosition);

		this.onChanged(ticketContainer);
		this.eventMode = EventMode.None;
	}

	private onChanged = (ticketContainer: TicketContainer) => {
		const data: Ticket = ticketContainer.getData();
		this.renderable = data.view.side === Side.PULL;
		if (this.renderable) {
			this.tint = ticketContainer.liveRoleTextColor;
			this._value.text = '' + data.view.liveDurationDays;
			this._value.tint = ticketContainer.liveRoleTextColor;
			this._value.calculateText();
			this.setPosition();
		}
	};

	private setPosition = () => {
		const data: Ticket = this.ticket.getData();
		const layout = this.ticket.getLayout();
		const width: number = this._value.isFancy ? (<any>this._value).widthPx : this._value.width;
		const ticketWidth = setTicketWidthHelper(data, layout, this.canvasAngularLand.wideTicketSize$.getValue());
		this.x = ticketWidth - this.width - width / 2 - 15;
		// padding-bottom: 20px
		// Align to bottom-left, then offset the height and 20
		// 28 is the height of TicketCrewSize.
		// 20 is the spacing we want.
		// Using the height of TicketCrewSize instead of this.height so all of the icons line-up neatly (Duration Days icon is larger than Crew Size)
		this.y =
			layout.height - TICKET_DURATION_DAYS_SETTINGS.ROW_HEIGHT - TICKET_DURATION_DAYS_SETTINGS.PADDING_BOTTOM;
	};

	public override destroy(options?) {
		this.ticket.off(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);
		this._value.removeAllListeners();
		this._value.destroy();
		super.destroy(options);
	}
}
